import { DEFAULT_LANG } from '../conf/languages';
import {
    PERMISSION_DEFAULT_END, PERMISSION_DEFAULT_NAME,
    PERMISSION_DEFAULT_START, PERMISSION_DEFAULT_TIMEZONE
} from '../conf/permissions';

export class Permission {
    Id: number;
    UserId: number;
    SiteId: number;
    Name: string;
    Description: string;
    Email: string;
    Tz: string;
    CustomerLanguage: string;
    Start: Date;
    End: Date;
    Token: string;
    InvitationSent: Date;
    PinCode: string;
    CreatedAt: Date;
    Status?: string;
    Commands?: PermittedCommand[];
    PinVisible: boolean;
    EnableRfid: boolean;
    EnablePincodeDevices: boolean;

    RfidQeCode?: string;
    RandomPincode?: boolean;
    SendPincodeRbe?: boolean;
    SendPincodeMtma?: boolean;
    SendRfidRbe?: boolean;
    SendRfidMtma?: boolean;
    SendMail?: boolean;
    SendAccessMail?: boolean;

    constructor() {
        this.Name = PERMISSION_DEFAULT_NAME;
        this.Start = PERMISSION_DEFAULT_START;
        this.End = PERMISSION_DEFAULT_END;
        this.Tz = PERMISSION_DEFAULT_TIMEZONE;
        this.CustomerLanguage = DEFAULT_LANG.code;
        this.PinVisible = false;
        this.PinCode = null;
        this.EnableRfid = false;
        this.EnablePincodeDevices = false;
        this.RfidQeCode = null;
        this.RandomPincode = true;
        this.SendPincodeRbe = true;
        this.SendPincodeMtma = true;
        this.SendRfidRbe = false;
        this.SendRfidMtma = false;
        this.SendMail = true;
        this.SendAccessMail = true;
    }
}

export interface PermissionEvent {
    PermissionId: number;
}

export class PermittedCommand {
    Id?: number;
    PermissionId?: number;
    DeviceId: number;
    DeviceName: string;
    CommandId: number;
    CmdId?: number;
    CommandDescription: string;
    Inactive?: boolean;

    constructor() {
        this.Id = 0;
        this.CommandId = 0;
        this.CommandDescription = '';
        this.DeviceId = 0;
        this.DeviceName = '';
    }
}

export class GroupedPermittedCommandsItem {
    DeviceName: string;
    items: PermittedCommand[];

    constructor(deviceName?, commands?) {
        this.DeviceName = deviceName || '';
        this.items = [];
        if (commands) {
            this.items = commands;
        }
    }
}

export enum EPermissionStatus {
    Created = 'created',
    Ready = 'ready',
    Active = 'active',
    Expired = 'expired',
}

export class PermissionTemplate {
    Id?: number;
    ExtraInfo?: string;
    Name?: string;
    Phone?: string;
    Email?: string;
    Website?: string;
    Address?: string;
    ImageId?: string;
}
